/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import { Link, useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import noImage from '../../../assets/images/no-image.png';
import { shortenStringWithTooltip } from '../../helper';
import ImageLazyLoader from '../../ImageLazyLoader';

function DamFolderGroupCard({ item, index, onCheck, onDelete, selectedIds, archiveUnArchivedFn, damAddEditAccess, damDeleteAccess }) {
  const isChecked = selectedIds?.filter((val) => val === item._id).length > 0;
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation('common');
  const activeState = location?.state?.activeList ? location?.state?.activeList : 'folder';

  useEffect(() => {
    if (location?.state?.activeList === undefined) {
      location.state = {
        ...location.state,
        activeList: 'folder',
      };
    }
  }, [location?.state?.activeList]);

  const getFullName = (obj) => {
    return `${obj?.firstName} ${obj?.lastName}`;
  };

  const onClickEvent = (item, e) => {
    if (e.detail === 2 && activeState !== 'bin') {
      history.push(`/digital-assets-management/folder/edit/${item._id}`);
    }
  };

  const renderImages = () => {
    if (item?.files?.length > 0) {
      return item.files
        .slice(0, 3)
        .map((file) => <ImageLazyLoader key={file?._id} src={file?.croppedImage || file?.imageUrl || file?.imageLink || file?.videoThumbnail || noImage} />);
    }

    if (item?.image) {
      return <ImageLazyLoader height="auto" src={item.image} />;
    }

    return <span className="icon-folder_new fs-folder" />;
  };

  return (
    <div id="accordion" className="col-lg-3 dam-card-container">
      <Card className="listing-card">
        <Card.Header>
          <div className="d-flex align-items-center min-h-40">
            <ul className="card-header-icon">
              {activeState !== 'bin' && damAddEditAccess && (
                <li>
                  <div className="cus-chk-block">
                    <input
                      onChange={(e) => {
                        onCheck(e, item._id, index);
                      }}
                      className="cursor-pointer"
                      name={`check_${index}`}
                      id={`check_${index}`}
                      type="checkbox"
                      checked={isChecked}
                    />
                    <label htmlFor={`check_${index}`} className="cus-chklabel" />
                  </div>
                </li>
              )}
              {activeState === 'folder' && damAddEditAccess && (
                <>
                  <li>
                    <Link
                      className="cursor-pointer text-dark text-decoration-none"
                      to={`/digital-assets-management/folder/edit/${item._id}`}
                      state={{ from: 'occupation' }}
                      title="Edit"
                    >
                      <i className="icon-edit" />
                    </Link>
                  </li>
                  <li onClick={() => history.push(`/digital-assets-management/folder/duplicate/${item._id}`, { isDuplicate: true })}>
                    <span title={t('DAM_FOLDER_VIEW.LISTING_VIEW.DUPLICATE_DAM_FOLDER')} aria-label={t('DAM_FOLDER_VIEW.LISTING_VIEW.DUPLICATE_DAM_FOLDER')}>
                      <i className="icon-duplicate cursor-pointer" />
                    </span>
                  </li>
                </>
              )}
              {activeState !== 'bin' && damAddEditAccess && (
                <li onClick={() => archiveUnArchivedFn(item?._id)}>
                  <span title={item?.isArchived ? 'Unarchive' : 'Archive'} aria-label={item?.isArchived ? 'Unarchive' : 'Archive'}>
                    <i className="icon-server cursor-pointer" />
                  </span>
                </li>
              )}
              {item?.isArchived && damDeleteAccess && (
                <li>
                  <span
                    title="Bin"
                    onClick={() => {
                      onDelete(item._id);
                    }}
                  >
                    <i className="icon-delete cursor-pointer" />
                  </span>
                </li>
              )}
            </ul>
            <div className="info-container xs-position-bottom iconfirst testing-action-spaceremoval">
              <span className="icon-info" />
              <div className="info-content text-nowrap">
                <p className="text-left m-0">
                  <strong>{t('CUSTOM_MODULE.CREATED')} </strong> :{' '}
                  {`${typeof item?.createdBy === 'object' ? getFullName(item?.createdBy) : item?.createdBy} ${
                    item?.createdAt && moment(item?.createdAt).format('DD-MMMM-YYYY, HH:mm')
                  }`}
                </p>

                <p className="text-left m-0">
                  <strong>{t('CUSTOM_MODULE.MODIFIED')} </strong> :{' '}
                  {`${typeof item?.modifiedBy === 'object' ? getFullName(item?.modifiedBy) : item?.modifiedBy} ${
                    item?.updatedAt && moment(item?.updatedAt).format('DD-MMMM-YYYY, HH:mm')
                  }`}
                </p>
              </div>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <ul className="card-ul">
            <li>
              <p className="font-weight-bold f-18 mb-0">{item?.name ? shortenStringWithTooltip(item.name, 15) : ''}</p>
            </li>
          </ul>
          <div className={`image-group image-${item?.files?.length}`} onClick={(e) => onClickEvent(item, e)}>
            {renderImages()}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default DamFolderGroupCard;
